import { render, staticRenderFns } from "./addExt.vue?vue&type=template&id=082900a0&scoped=true"
import script from "./addExt.vue?vue&type=script&lang=js"
export * from "./addExt.vue?vue&type=script&lang=js"
import style0 from "./addExt.vue?vue&type=style&index=0&id=082900a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082900a0",
  null
  
)

export default component.exports